<script>
  import BaseContentSet from '../BaseContentSet/BaseContentSet.svelte';
  import { getPath } from '../../utils/imageKit.ts';

  let {
    baseContent,
    backgroundImage,
    alignment = 'left',
    lazyloadImage = true,
    reducedImageHeight = false,
    lang,
    dataTestId = 'marketing-full-size-image',
  } = $props();

  // Handle Image Setup
  const moDefaultSrc = getPath(backgroundImage, { w: 343, h: 228 });
  const moHighResSrc = getPath(backgroundImage, { w: 343, h: 228 }, 2);
  const smDefaultSrc = getPath(backgroundImage, { w: 593, h: 395 });
  const smHighResSrc = getPath(backgroundImage, { w: 593, h: 395 }, 2);
  const mdDefaultSrc = getPath(backgroundImage, { w: 721, h: 440 });
  const mdHighResSrc = getPath(backgroundImage, { w: 721, h: 440 }, 2);
  const lgDefaultSrc = getPath(backgroundImage, { w: 496, h: 448 });
  const lgHighResSrc = getPath(backgroundImage, { w: 496, h: 448 }, 2);
  const xlDefaultSrc = getPath(backgroundImage, { w: 576, h: 448 });
  const xlHighResSrc = getPath(backgroundImage, { w: 576, h: 448 }, 2);
</script>

<div data-testid={dataTestId} class="my-6 md:my-10 lg:my-14 max-w-6xl lg:mx-auto">
  <div
    class="flex flex-col shadow-y-sm lg:shadow-y-lg bg-white mx-4"
    class:lg:min-h-112={!reducedImageHeight}
    class:lg:flex-row={alignment == 'left'}
    class:lg:flex-row-reverse={alignment == 'right'}
  >
    <div class="w-full lg:w-1/2">
      {#if backgroundImage && backgroundImage.url && backgroundImage.alt}
        <picture>
          <source media="(min-width: 1280px)" srcset={`${xlDefaultSrc}, ${xlHighResSrc} 2x`} />
          <source media="(min-width: 1024px)" srcset={`${lgDefaultSrc}, ${lgHighResSrc} 2x`} />
          <source media="(min-width: 768px)" srcset={`${mdDefaultSrc}, ${mdHighResSrc} 2x`} />
          <source media="(min-width: 640px)" srcset={`${smDefaultSrc}, ${smHighResSrc} 2x`} />
          <source media="(max-width: 639px)" srcset={`${moDefaultSrc}, ${moHighResSrc} 2x`} />
          <img
            class="object-cover h-full w-full"
            loading={lazyloadImage === true ? 'lazy' : 'eager'}
            class:max-h-64={reducedImageHeight}
            class:md:max-h-94={reducedImageHeight}
            width="343"
            height="228"
            src={moDefaultSrc}
            alt={backgroundImage.alt}
          />
        </picture>
      {/if}
    </div>
    <BaseContentSet
      {...baseContent}
      lang={lang || 'en'}
      className="p-8 lg:p-12 w-full lg:w-1/2 flex flex-col justify-center"
    />
  </div>
</div>
